import { N as m, _ as A, P as $, t as c } from "./export-cdcbfb2b.js";
import { i as g, b as u } from "./array-iteration-759bfbfa.js";
import { d as b } from "./es.array.concat-d1c9b847.js";
import { f as I } from "./es.object.to-string-f55666a8.js";
import { b as h } from "./create-property-f9780ed1.js";
var x = g, O = m, C = b, L = I, p = function(s, n, a, f, r, i, l, y) {
  for (var e = r, t = 0, v = l ? L(l, y) : !1, o, d; t < f; )
    t in a && (o = v ? v(a[t], t, n) : a[t], i > 0 && x(o) ? (d = O(o), e = p(s, n, o, d, e, i - 1) - 1) : (C(e + 1), s[e] = o), e++), t++;
  return e;
}, S = p, M = A, N = S, _ = $, j = c, k = m, E = u;
M({ target: "Array", proto: !0 }, {
  flatMap: function(n) {
    var a = j(this), f = k(a), r;
    return _(n), r = E(a, 0), r.length = N(r, a, a, f, 0, 1, n, arguments.length > 1 ? arguments[1] : void 0), r;
  }
});
var T = h;
T("flatMap");
